<template>
  <div id="app">
    <weixin-tip/>
    <web-header/>
    <router-view/>
    <slide-bar/>
    <web-footer/>
    <div id="bottom-remind" class="bottom-remind" v-show="remindOpen">
      <div class="text">
        <p>
          您的浏览器版本较低，即将停止升级维护，建议升级到更快、更安全的浏览器(推荐<a href="http://sw.bos.baidu.com/sw-search-sp/software/3d03c3764837b/ChromeStandalone_52.0.2743.116_Setup.exe">谷歌</a>、<a href="http://sw.bos.baidu.com/sw-search-sp/software/9d088e907eea2/Firefox_48.0.2.6079_setup.exe">火狐</a>或其他最新浏览器使用)。
        </p>
      </div>
      <a class="close" @click.stop.prevent="closeRemind">
        <i></i>
        <!--<span>关闭</span>-->
      </a>
    </div>
  </div>
</template>

<script>
import webFooter from './components/websiteFooter'
import webHeader from './components/websiteHeader'
import slideBar from './components/slideBar'
import weixinTip from './components/weixinTip'
import {testType} from './config/mUtils'
export default {
  name: 'App',
  data () {
    return {
      remindOpen: false
    }
  },
  created () {
    var userAgent = navigator.userAgent
    var type = testType()
    if (type === "IE") {
      var reIE = new RegExp("MSIE (\\d+\\.\\d+);")
      reIE.test(userAgent)
      var fIEVersion = parseFloat(RegExp["$1"])
      if (fIEVersion < 9) {
        this.remindOpen = true
      }
    }
  },
  methods: {
    closeRemind () {
      this.remindOpen = false
    }
  },
  components: {
    weixinTip,
    webFooter,
    webHeader,
    slideBar
  }
}
</script>

<style>
  @import "assets/css/base.css";

  /*IE小于10的提示*/
  #app{
    background: #fafafa;
  }
  .bottom-remind, .video-remind{
    position: relative;
    width: 100%;
    position: fixed;
    z-index: 1032;
    bottom: 0;
    left: 0;
    background-color: #FFCE00;
    padding-top: 10px;
  }

  .bottom-remind .close,
  .video-remind .close{
    display: inline-block;
    position: absolute;
    top: 10px;
    right: 0;
    overflow: hidden;
    opacity: 1;
  }

  .close i{
    background: url('assets/image/comment/close.png') no-repeat;
    width: 40px;
    height: 40px;
    display: block;
    margin-top:0;
  }
  .close:hover i{
    opacity: .5;
  }

  .bottom-remind .text,
  .video-remind .text{
    padding-left: 80px;
    padding-right: 80px;
  }
  .bottom-remind .text p,
  .video-remind .text p{
    font-size: 18px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue